export default "__VITE_ASSET__Dtd94qqd__"